import type { Movie, HeroSlide, CategoryMeta } from "@/types/movie";

export const movies: Movie[] = [
  {
    id: "mv-001",
    title: "星海远航",
    type: "movie",
    region: "国产",
    year: 2024,
    rating: 8.8,
    heat: 328000,
    duration: "142分钟",
    director: "陈屿",
    actors: ["周牧", "林晚", "苏哲"],
    updateDate: "2024-09-18",
    tags: ["科幻", "冒险", "太空"],
    description:
      "一支深空远征队为寻找人类新家园踏上漫长航程，在未知星域遭遇能量风暴与失落文明的遗迹。面对资源枯竭与内部裂痕，船员们必须在信念与生存之间做出抉择。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20deep%20space%20adventure%20movie%20poster%2C%20lone%20astronaut%20silhouette%20before%20a%20glowing%20nebula%2C%20deep%20blue%20and%20starfield%20tones%2C%20dramatic%20lighting%2C%20stylized%20artistic%20illustration%2C%20minimal%20composition%20with%20room%20for%20title&width=480&height=720&seq=poster-mv001&orientation=portrait",
  },
  {
    id: "mv-002",
    title: "暗夜追凶",
    type: "movie",
    region: "欧美",
    year: 2023,
    rating: 8.5,
    heat: 296500,
    duration: "128分钟",
    director: "Ethan Cole",
    actors: ["Marcus Reed", "Elena Voss"],
    updateDate: "2024-08-30",
    tags: ["悬疑", "犯罪", "惊悚"],
    description:
      "雨夜的都市接连发生离奇案件，一名固执的侦探在层层迷雾中追踪真凶。随着线索逐渐拼合，他发现真相与自己尘封的过去紧紧相连，正义与复仇的界限开始模糊。",
    cover:
      "https://readdy.ai/api/search-image?query=noir%20crime%20thriller%20movie%20poster%2C%20rainy%20city%20street%20at%20night%20with%20a%20detective%20silhouette%2C%20orange%20street%20light%20against%20deep%20blue%20darkness%2C%20moody%20atmosphere%2C%20stylized%20artistic%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv002&orientation=portrait",
  },
  {
    id: "mv-003",
    title: "长安月下",
    type: "tvseries",
    region: "国产",
    year: 2024,
    rating: 9.1,
    heat: 512000,
    duration: "共45集",
    director: "沈墨白",
    actors: ["顾清欢", "萧无衣", "裴行"],
    updateDate: "2024-09-25",
    tags: ["古装", "历史", "权谋"],
    description:
      "长安城表面繁华似锦，暗处却暗流涌动。一位身世成谜的少女卷入朝堂纷争，在权谋与情义之间步步为营，用智慧与勇气书写属于自己的传奇，守护心中的家国天下。",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20historical%20drama%20poster%2C%20a%20figure%20in%20flowing%20robes%20before%20a%20moonlit%20palace%2C%20deep%20blue%20night%20sky%20with%20warm%20orange%20lantern%20glow%2C%20elegant%20stylized%20illustration%2C%20minimal%20serene%20composition&width=480&height=720&seq=poster-mv003&orientation=portrait",
  },
  {
    id: "mv-004",
    title: "都市心跳",
    type: "tvseries",
    region: "国产",
    year: 2023,
    rating: 7.9,
    heat: 264300,
    duration: "共36集",
    director: "何晓棠",
    actors: ["许知意", "沈亦然"],
    updateDate: "2024-07-12",
    tags: ["都市", "爱情", "职场"],
    description:
      "在快节奏的都市里，两位性格迥异的年轻人因一次意外相遇。从针锋相对到彼此治愈，他们在职场压力与生活琐碎中重新理解爱与成长，也找到了属于自己的生活节奏。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20urban%20romance%20drama%20poster%2C%20two%20young%20people%20on%20a%20city%20rooftop%20at%20dusk%2C%20warm%20orange%20sunset%20against%20deep%20blue%20skyline%2C%20soft%20cinematic%20lighting%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv004&orientation=portrait",
  },
  {
    id: "mv-005",
    title: "东京物语·新篇",
    type: "movie",
    region: "日韩",
    year: 2022,
    rating: 8.2,
    heat: 189600,
    duration: "118分钟",
    director: "佐藤井",
    actors: ["田中涼子", "小林健"],
    updateDate: "2024-06-20",
    tags: ["剧情", "家庭", "温情"],
    description:
      "一对年迈的父母前往大城市探望忙碌的子女，却发现彼此早已生活在不同的世界。平淡的日常里藏着说不出口的牵挂，影片用细腻的笔触描绘现代家庭的疏离与羁绊。",
    cover:
      "https://readdy.ai/api/search-image?query=japanese%20gentle%20family%20drama%20poster%2C%20quiet%20tokyo%20suburb%20at%20twilight%20with%20soft%20warm%20window%20lights%2C%20muted%20deep%20blue%20evening%20tones%2C%20calm%20nostalgic%20mood%2C%20stylized%20artistic%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv005&orientation=portrait",
  },
  {
    id: "mv-006",
    title: "极速边境",
    type: "movie",
    region: "欧美",
    year: 2024,
    rating: 7.6,
    heat: 341200,
    duration: "130分钟",
    director: "Diego Alvarez",
    actors: ["Cole Harris", "Mia Delgado"],
    updateDate: "2024-09-10",
    tags: ["动作", "赛车", "犯罪"],
    description:
      "一名退役车手为救回被卷入走私集团的弟弟，被迫重回地下赛车世界。在横跨边境的生死狂飙中，速度既是武器也是枷锁，他必须在终点线前完成自我救赎。",
    cover:
      "https://readdy.ai/api/search-image?query=high%20speed%20racing%20action%20movie%20poster%2C%20sports%20car%20with%20glowing%20tail%20lights%20speeding%20on%20a%20night%20highway%2C%20orange%20light%20trails%20against%20deep%20blue%20dark%2C%20dynamic%20motion%20blur%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv006&orientation=portrait",
  },
  {
    id: "mv-007",
    title: "迷雾森林",
    type: "tvseries",
    region: "欧美",
    year: 2023,
    rating: 8.7,
    heat: 387400,
    duration: "共24集",
    director: "Sarah Blake",
    actors: ["Noah Frost", "Ivy Stone"],
    updateDate: "2024-08-05",
    tags: ["惊悚", "悬疑", "奇幻"],
    description:
      "小镇边缘的森林终年被浓雾笼罩，失踪事件接连发生。一位记者深入调查，逐渐揭开小镇隐瞒多年的秘密，也发现迷雾之中潜伏着超越常理的存在。",
    cover:
      "https://readdy.ai/api/search-image?query=mysterious%20misty%20forest%20thriller%20poster%2C%20dark%20pine%20trees%20in%20thick%20fog%20with%20a%20faint%20orange%20glow%20between%20trunks%2C%20deep%20blue%20and%20teal%20tones%2C%20eerie%20atmospheric%20mood%2C%20stylized%20artistic%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv007&orientation=portrait",
  },
  {
    id: "mv-008",
    title: "少年江湖",
    type: "tvseries",
    region: "国产",
    year: 2022,
    rating: 7.4,
    heat: 176800,
    duration: "共40集",
    director: "秦川",
    actors: ["陆时安", "江雪见"],
    updateDate: "2024-05-28",
    tags: ["武侠", "青春", "热血"],
    description:
      "出身平凡的山村少年怀揣侠客梦踏入江湖，在恩怨情仇与门派纷争中结识挚友、历经磨砺。从懵懂到担当，他用一腔热血诠释何为真正的侠义之心。",
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20wuxia%20martial%20arts%20youth%20drama%20poster%2C%20young%20swordsman%20on%20a%20cliff%20watching%20misty%20mountains%2C%20deep%20blue%20with%20warm%20orange%20sunrise%20accents%2C%20energetic%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv008&orientation=portrait",
  },
  {
    id: "mv-009",
    title: "星际移民",
    type: "movie",
    region: "欧美",
    year: 2024,
    rating: 8.9,
    heat: 468900,
    duration: "155分钟",
    director: "Christopher Nye",
    actors: ["Daniel Cross", "Amara Osei"],
    updateDate: "2024-09-22",
    tags: ["科幻", "冒险", "史诗"],
    description:
      "地球资源濒临枯竭，人类启动史上最大规模的星际移民计划。一艘承载着希望的方舟穿越虫洞，却遭遇时间错位与未知文明。人性的光辉与阴影在孤独航程中被无限放大。",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20sci%20fi%20space%20migration%20movie%20poster%2C%20massive%20generation%20spaceship%20near%20a%20glowing%20wormhole%2C%20deep%20blue%20and%20orange%20accent%20lighting%2C%20awe%20inspiring%20scale%2C%20stylized%20artistic%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv009&orientation=portrait",
  },
  {
    id: "mv-010",
    title: "京城旧梦",
    type: "tvseries",
    region: "国产",
    year: 2023,
    rating: 8.3,
    heat: 253700,
    duration: "共38集",
    director: "白砚",
    actors: ["宋知微", "程亦寒"],
    updateDate: "2024-07-30",
    tags: ["年代", "剧情", "家族"],
    description:
      "上世纪三十年代的北平，一个没落家族的三兄妹在时代洪流中各自求索。旧梦与新潮激烈碰撞，他们守护着家族的尊严，也见证了一座古城与一个时代的变迁。",
    cover:
      "https://readdy.ai/api/search-image?query=retro%20chinese%20period%20drama%20poster%2C%20vintage%20beijing%20courtyard%20at%20dusk%20with%20warm%20lantern%20light%2C%20muted%20deep%20blue%20evening%20shadows%2C%20nostalgic%20cinematic%20mood%2C%20stylized%20artistic%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv010&orientation=portrait",
  },
  {
    id: "mv-011",
    title: "首尔恋人",
    type: "tvseries",
    region: "日韩",
    year: 2024,
    rating: 8.0,
    heat: 298100,
    duration: "共16集",
    director: "金智勋",
    actors: ["朴雅琳", "李在禹"],
    updateDate: "2024-09-14",
    tags: ["爱情", "都市", "治愈"],
    description:
      "一位咖啡师与一位冷淡的建筑师因一间即将拆迁的老咖啡馆相识。在一杯杯咖啡与一次次深夜长谈中，两人慢慢打开心防，学会与过去和解，也重新相信爱情。",
    cover:
      "https://readdy.ai/api/search-image?query=seoul%20urban%20romance%20korean%20drama%20poster%2C%20cozy%20coffee%20shop%20window%20at%20night%20with%20warm%20orange%20light%2C%20deep%20blue%20city%20street%20reflections%2C%20soft%20romantic%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv011&orientation=portrait",
  },
  {
    id: "mv-012",
    title: "深海迷航",
    type: "movie",
    region: "国产",
    year: 2023,
    rating: 7.7,
    heat: 221400,
    duration: "124分钟",
    director: "罗远山",
    actors: ["秦海", "叶清澜"],
    updateDate: "2024-07-02",
    tags: ["科幻", "悬疑", "灾难"],
    description:
      "一艘深海科考潜艇在万米海沟失联，救援队下潜后发现了颠覆认知的生态与未知信号。当黑暗中的威胁逐渐逼近，生存成为唯一目标，人类在极限环境下面临最严峻的考验。",
    cover:
      "https://readdy.ai/api/search-image?query=deep%20sea%20submarine%20sci%20fi%20poster%2C%20submersible%20descending%20into%20dark%20ocean%20trench%20with%20bioluminescent%20glow%2C%20deep%20blue%20and%20teal%20with%20faint%20orange%20light%2C%20tense%20underwater%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv012&orientation=portrait",
  },
  {
    id: "mv-013",
    title: "荒野求生记",
    type: "movie",
    region: "欧美",
    year: 2022,
    rating: 7.2,
    heat: 143900,
    duration: "106分钟",
    director: "Liam Ford",
    actors: ["Jake Miller", "Rosa Lin"],
    updateDate: "2024-04-18",
    tags: ["冒险", "生存", "剧情"],
    description:
      "一次意外的飞机失事让一名城市白领独自困于原始荒野。从手足无措到与自然达成和解，他在一次次生死考验中找回被现代生活磨平的本能与勇气。",
    cover:
      "https://readdy.ai/api/search-image?query=wilderness%20survival%20adventure%20movie%20poster%2C%20lone%20hiker%20before%20vast%20mountain%20wilderness%20at%20dawn%2C%20deep%20blue%20dawn%20sky%20with%20warm%20orange%20horizon%20glow%2C%20rugged%20epic%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv013&orientation=portrait",
  },
  {
    id: "mv-014",
    title: "春天音乐会",
    type: "movie",
    region: "日韩",
    year: 2023,
    rating: 8.6,
    heat: 168700,
    duration: "112分钟",
    director: "中村悠斗",
    actors: ["山本葵", "高桥凉"],
    updateDate: "2024-06-08",
    tags: ["音乐", "剧情", "励志"],
    description:
      "一位失去听觉的少年钢琴手与一位落魄的指挥家意外结缘。在春天的城市里，他们用震动与记忆重新编织旋律，奏响一场献给坚持与热爱的动人乐章。",
    cover:
      "https://readdy.ai/api/search-image?query=spring%20music%20concert%20japanese%20film%20poster%2C%20grand%20piano%20under%20cherry%20blossoms%20at%20dusk%2C%20deep%20blue%20evening%20with%20warm%20orange%20stage%20light%2C%20dreamy%20emotional%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv014&orientation=portrait",
  },
  {
    id: "mv-015",
    title: "大时代",
    type: "tvseries",
    region: "国产",
    year: 2021,
    rating: 8.4,
    heat: 207500,
    duration: "共52集",
    director: "郑云舟",
    actors: ["方国栋", "苏晚晴"],
    updateDate: "2024-03-25",
    tags: ["商战", "年代", "剧情"],
    description:
      "改革开放的浪潮中，一群年轻人白手起家，在商海沉浮里追逐梦想。财富、友情、亲情与信念相互交织，他们用三十年书写了一部属于大时代的奋斗史诗。",
    cover:
      "https://readdy.ai/api/search-image?query=chinese%20business%20era%20drama%20poster%2C%20silhouette%20looking%20over%20a%20growing%20city%20skyline%20at%20night%2C%20deep%20blue%20city%20lights%20with%20warm%20orange%20accents%2C%20ambitious%20cinematic%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv015&orientation=portrait",
  },
  {
    id: "mv-016",
    title: "幽灵代码",
    type: "movie",
    region: "欧美",
    year: 2024,
    rating: 7.8,
    heat: 312600,
    duration: "118分钟",
    director: "Nathan Pryce",
    actors: ["Owen Blake", "Zara Quinn"],
    updateDate: "2024-09-02",
    tags: ["科幻", "惊悚", "黑客"],
    description:
      "一名天才安全专家发现一段能自我进化的神秘代码正在吞噬全球网络。在追查源头的过程中，她惊觉自己可能就是这场数字灾难的钥匙，现实与虚拟的边界逐渐崩塌。",
    cover:
      "https://readdy.ai/api/search-image?query=cyber%20hacker%20sci%20fi%20thriller%20poster%2C%20glowing%20digital%20code%20streams%20forming%20a%20face%20in%20darkness%2C%20deep%20blue%20and%20cyan%20with%20orange%20error%20glow%2C%20futuristic%20tense%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv016&orientation=portrait",
  },
  {
    id: "mv-017",
    title: "海街日记·夏",
    type: "tvseries",
    region: "日韩",
    year: 2022,
    rating: 8.5,
    heat: 154200,
    duration: "共12集",
    director: "秋元真",
    actors: ["森川结衣", "青木遥"],
    updateDate: "2024-05-10",
    tags: ["温情", "生活", "治愈"],
    description:
      "海边小镇的一间老屋住着四姐妹，她们在蝉鸣与潮声中过着平凡而温暖的日子。生活的琐碎、各自的烦恼与隐秘的心事，都在夏日海风里被轻轻抚平。",
    cover:
      "https://readdy.ai/api/search-image?query=seaside%20slice%20of%20life%20japanese%20drama%20poster%2C%20traditional%20seaside%20house%20by%20the%20ocean%20at%20golden%20hour%2C%20deep%20blue%20sea%20with%20warm%20orange%20sundown%2C%20peaceful%20nostalgic%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv017&orientation=portrait",
  },
  {
    id: "mv-018",
    title: "铁血将军",
    type: "tvseries",
    region: "国产",
    year: 2023,
    rating: 8.1,
    heat: 198300,
    duration: "共44集",
    director: "岳长风",
    actors: ["霍霆", "江慕白"],
    updateDate: "2024-06-28",
    tags: ["战争", "历史", "热血"],
    description:
      "战火纷飞的年代，一位出身寒门的将领带领部队浴血奋战。他既是战场上的铁血统帅，也是有血有肉的兄长与父亲。硝烟背后，是他对家国最深沉的忠诚与守护。",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20war%20historical%20drama%20poster%2C%20armored%20general%20silhouette%20before%20a%20battlefield%20at%20dusk%2C%20deep%20blue%20smoke%20with%20warm%20orange%20fire%20glow%2C%20solemn%20heroic%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv018&orientation=portrait",
  },
  {
    id: "mv-019",
    title: "时间裂缝",
    type: "movie",
    region: "欧美",
    year: 2023,
    rating: 8.3,
    heat: 279400,
    duration: "134分钟",
    director: "Alice Monroe",
    actors: ["Ryan Vale", "Sofia Reyes"],
    updateDate: "2024-07-18",
    tags: ["科幻", "悬疑", "剧情"],
    description:
      "一位物理学家在实验中意外打开了时间裂缝，为了挽回一场无法接受的失去，她一次次穿越回过去。然而每改变一次过去，现实就以更危险的方式崩塌。",
    cover:
      "https://readdy.ai/api/search-image?query=time%20travel%20sci%20fi%20poster%2C%20figure%20before%20a%20fractured%20glowing%20portal%20with%20shattered%20glass%20shards%2C%20deep%20blue%20and%20violet%20tones%20with%20orange%20energy%2C%20mysterious%20cinematic%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv019&orientation=portrait",
  },
  {
    id: "mv-020",
    title: "小城故事",
    type: "movie",
    region: "国产",
    year: 2022,
    rating: 7.9,
    heat: 132700,
    duration: "110分钟",
    director: "林知远",
    actors: ["顾长风", "柳依依"],
    updateDate: "2024-02-14",
    tags: ["剧情", "文艺", "生活"],
    description:
      "南方小城的梅雨季节，一位返乡青年与留守的旧友重逢。平淡的日常里装着各自的理想与遗憾，他们在这座慢慢变化的小城里，重新寻找生活的方向与意义。",
    cover:
      "https://readdy.ai/api/search-image?query=quiet%20southern%20chinese%20town%20art%20film%20poster%2C%20rainy%20old%20street%20with%20warm%20window%20lights%20reflected%20in%20puddles%2C%20deep%20blue%20rainy%20tones%20with%20orange%20glow%2C%20melancholic%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv020&orientation=portrait",
  },
  {
    id: "mv-021",
    title: "王牌特工队",
    type: "movie",
    region: "欧美",
    year: 2024,
    rating: 7.5,
    heat: 356800,
    duration: "126分钟",
    director: "Ben Carter",
    actors: ["Leo Grant", "Nina Park"],
    updateDate: "2024-09-06",
    tags: ["动作", "喜剧", "间谍"],
    description:
      "一支被解散的杂牌特工小队被临时召集，执行一项没人愿意接的危险任务。乌龙与枪火齐飞，这群不靠谱的家伙竟在混乱中打出了属于自己的默契与荣耀。",
    cover:
      "https://readdy.ai/api/search-image?query=action%20spy%20comedy%20movie%20poster%2C%20stylish%20agents%20silhouette%20with%20geometric%20shapes%20and%20crosshair%20motif%2C%20deep%20blue%20background%20with%20bold%20orange%20accents%2C%20playful%20dynamic%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv021&orientation=portrait",
  },
  {
    id: "mv-022",
    title: "山海秘境",
    type: "tvseries",
    region: "国产",
    year: 2024,
    rating: 8.8,
    heat: 445600,
    duration: "共40集",
    director: "白泽",
    actors: ["云绯", "墨渊", "青璃"],
    updateDate: "2024-09-20",
    tags: ["奇幻", "古装", "冒险"],
    description:
      "古籍中记载的山海秘境重新现世，一位少女与神秘少年结伴踏上寻访之旅。奇珍异兽、上古遗迹与隐藏千年的真相层层展开，一场关乎天地秩序的冒险就此启程。",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20ancient%20chinese%20mythical%20drama%20poster%2C%20floating%20islands%20and%20mythical%20beasts%20among%20clouds%2C%20deep%20blue%20sky%20with%20warm%20orange%20sunlight%2C%20grand%20mystical%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv022&orientation=portrait",
  },
  {
    id: "mv-023",
    title: "午夜电台",
    type: "movie",
    region: "日韩",
    year: 2023,
    rating: 7.7,
    heat: 121500,
    duration: "104分钟",
    director: "黑木凌",
    actors: ["桐生刹那", "水野玲"],
    updateDate: "2024-04-30",
    tags: ["悬疑", "剧情", "惊悚"],
    description:
      "一位深夜电台主播在直播中接到一通声称来自未来的来电。随着节目进行，电话里的预言逐一应验，她必须在午夜零点前做出一个改变一切的决定。",
    cover:
      "https://readdy.ai/api/search-image?query=late%20night%20radio%20mystery%20film%20poster%2C%20vintage%20microphone%20in%20a%20dark%20studio%20with%20glowing%20sound%20waves%2C%20deep%20blue%20darkness%20with%20warm%20orange%20indicator%20light%2C%20suspenseful%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv023&orientation=portrait",
  },
  {
    id: "mv-024",
    title: "荣耀之路",
    type: "tvseries",
    region: "欧美",
    year: 2024,
    rating: 8.6,
    heat: 289700,
    duration: "共20集",
    director: "Grace Hall",
    actors: ["Tyler Brooks", "Ava Mason"],
    updateDate: "2024-09-16",
    tags: ["体育", "励志", "剧情"],
    description:
      "一支连败多年的城市球队在新教练的带领下重新出发。伤病、质疑与内讧接踵而至，队员们却在一次次失败中学会了信任与坚持，向着久违的冠军奖杯奋力奔跑。",
    cover:
      "https://readdy.ai/api/search-image?query=sports%20underdog%20drama%20poster%2C%20stadium%20floodlights%20over%20an%20empty%20field%20with%20a%20lone%20athlete%2C%20deep%20blue%20night%20with%20warm%20orange%20stadium%20glow%2C%20inspiring%20cinematic%20mood%2C%20stylized%20illustration%2C%20minimal%20composition&width=480&height=720&seq=poster-mv024&orientation=portrait",
  },
];

export const heroSlides: HeroSlide[] = [
  {
    id: "hero-1",
    movieId: "mv-009",
    title: "星际移民",
    subtitle: "年度科幻史诗",
    description:
      "地球资源濒临枯竭，人类启动史上最大规模的星际移民计划。一艘承载希望的方舟穿越虫洞，人性的光辉与阴影在孤独航程中被无限放大。",
    tags: ["科幻", "冒险", "史诗"],
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20cinematic%20space%20scene%2C%20massive%20generation%20spaceship%20near%20a%20glowing%20blue%20wormhole%20surrounded%20by%20stars%2C%20deep%20blue%20and%20orange%20accent%20lighting%2C%20awe%20inspiring%20scale%2C%20stylized%20artistic%20wide%20illustration%20with%20dark%20space%20for%20text&width=1600&height=900&seq=hero-mv009&orientation=landscape",
  },
  {
    id: "hero-2",
    movieId: "mv-003",
    title: "长安月下",
    subtitle: "古装权谋大剧",
    description:
      "长安城表面繁华似锦，暗处却暗流涌动。一位身世成谜的少女卷入朝堂纷争，在权谋与情义之间步步为营，守护心中的家国天下。",
    tags: ["古装", "历史", "权谋"],
    backdrop:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20imperial%20palace%20at%20night%2C%20moonlit%20rooftops%20with%20warm%20orange%20lanterns%20glowing%2C%20deep%20blue%20night%20sky%2C%20elegant%20serene%20wide%20stylized%20illustration%20with%20dark%20area%20for%20text&width=1600&height=900&seq=hero-mv003&orientation=landscape",
  },
  {
    id: "hero-3",
    movieId: "mv-022",
    title: "山海秘境",
    subtitle: "奇幻冒险新作",
    description:
      "古籍中记载的山海秘境重新现世，一位少女与神秘少年结伴踏上寻访之旅。奇珍异兽、上古遗迹与隐藏千年的真相层层展开。",
    tags: ["奇幻", "古装", "冒险"],
    backdrop:
      "https://readdy.ai/api/search-image?query=mystical%20fantasy%20ancient%20china%20landscape%2C%20floating%20islands%20among%20clouds%20with%20mythical%20creatures%2C%20deep%20blue%20sky%20with%20warm%20orange%20sunlight%2C%20grand%20ethereal%20wide%20stylized%20illustration%20with%20dark%20area%20for%20text&width=1600&height=900&seq=hero-mv022&orientation=landscape",
  },
  {
    id: "hero-4",
    movieId: "mv-002",
    title: "暗夜追凶",
    subtitle: "高口碑犯罪悬疑",
    description:
      "雨夜的都市接连发生离奇案件，一名固执的侦探在层层迷雾中追踪真凶。随着线索逐渐拼合，真相与他尘封的过去紧紧相连。",
    tags: ["悬疑", "犯罪", "惊悚"],
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20noir%20rainy%20city%20at%20night%2C%20lonely%20detective%20silhouette%20under%20orange%20streetlight%20with%20wet%20reflections%2C%20deep%20blue%20darkness%2C%20moody%20wide%20stylized%20illustration%20with%20dark%20area%20for%20text&width=1600&height=900&seq=hero-mv002&orientation=landscape",
  },
  {
    id: "hero-5",
    movieId: "mv-024",
    title: "荣耀之路",
    subtitle: "热血体育励志",
    description:
      "一支连败多年的城市球队在新教练的带领下重新出发。队员们却在一次次失败中学会了信任与坚持，向着久违的冠军奖杯奋力奔跑。",
    tags: ["体育", "励志", "剧情"],
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20sports%20stadium%20at%20night%2C%20bright%20floodlights%20over%20the%20field%20with%20a%20lone%20athlete%20silhouette%2C%20deep%20blue%20night%20with%20warm%20orange%20glow%2C%20inspiring%20wide%20stylized%20illustration%20with%20dark%20area%20for%20text&width=1600&height=900&seq=hero-mv024&orientation=landscape",
  },
];

export const categoryMeta: CategoryMeta[] = [
  {
    key: "movie",
    label: "电影",
    title: "电影 - 蓝莓视频高清影视资源",
    description:
      "汇集科幻、动作、悬疑、剧情等多元类型的高清电影资源，涵盖院线新片与影史经典，随时畅享大银幕级的观影体验。",
  },
  {
    key: "tvseries",
    label: "电视剧",
    title: "电视剧 - 蓝莓视频高清影视资源",
    description:
      "聚合古装、都市、悬疑、家庭等热门剧集，国产、欧美、日韩好剧一网打尽，追剧不停歇。",
  },
  {
    key: "latest",
    label: "最新",
    title: "最新上线 - 蓝莓视频高清影视资源",
    description:
      "第一时间汇总近期上线的电影与电视剧，紧随热点，不错过任何一部新作。",
  },
  {
    key: "hot",
    label: "热门",
    title: "热门推荐 - 蓝莓视频高清影视资源",
    description:
      "根据播放热度精选高人气影视作品，大众都在看的口碑佳作尽在于此。",
  },
  {
    key: "china",
    label: "国产",
    title: "国产影视 - 蓝莓视频高清影视资源",
    description:
      "精选优质国产电影与电视剧，从古装权谋到现代都市，展现华语影视的多元魅力。",
  },
  {
    key: "overseas",
    label: "海外",
    title: "欧美影视 - 蓝莓视频高清影视资源",
    description:
      "网罗欧美高分电影与剧集，科幻、犯罪、动作、体育应有尽有，感受国际化的叙事魅力。",
  },
  {
    key: "japankorea",
    label: "日韩",
    title: "日韩影视 - 蓝莓视频高清影视资源",
    description:
      "聚焦日韩温情剧集与治愈系电影，细腻的情感表达与独特的生活美学等你发现。",
  },
];